import React from "react";
import CustomNavbar from "../components/CustomNavbar";
import EbookdataBookDetail from "../components/Team/EbookdataBookDetail";
import FooterAmani from "../components/Footer/FooterAmani";
const EbookdataBook = () => {
  return (
    <div className="body_wrapper">
        <CustomNavbar mClass="erp_menu" hbtnClass="er_btn" nClass="mr-auto" />
      {/* <Breadcrumb
        breadcrumbClass="breadcrumb_area breadcrumb_area_three"
        imgName="Img-05.jpg"
        Ptitle="Our EbookdataBook"
        Pdescription="Why I say old chap that is spiffing off his nut arse pear shaped plastered Jeffrey bodge barney some dodgy.!!"
      /> */}
      <EbookdataBookDetail/>
      {/* <FooterTwo FooterData={FooterData} /> */}
      <FooterAmani/>
    </div>
  );
};
export default EbookdataBook;
